/**
 * Leituras sobre os agendamentos da ficha (`appointments.history` e
 * `appointments.upcoming` do get_patient.php), compartilhadas pelo resumo do
 * cabeçalho e pela seção Agendamentos.
 */

const pad = (n) => String(n).padStart(2, '0');

export const formatDateBR = (date) => `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`;

export const formatTimeBR = (date) => `${pad(date.getHours())}:${pad(date.getMinutes())}`;

/** Último atendimento realizado (a lista vem do mais recente para o mais antigo). */
export function getLastCompleted(history) {
  const item = (history || []).find((appointment) => appointment.status === 'completed');
  return item ? new Date(item.date) : null;
}

/** Próximo agendamento (a lista vem do mais próximo para o mais distante). */
export function getNextUpcoming(upcoming) {
  const item = (upcoming || [])[0];
  return item ? new Date(item.date) : null;
}

/** "2 anos, 3 meses e 4 dias" desde a data; "Hoje" no mesmo dia. */
export function timeSince(date) {
  const days = Math.floor((new Date() - date) / (1000 * 60 * 60 * 24));
  const years = Math.floor(days / 365);
  const remaining = days % 365;
  const months = Math.floor(remaining / 30);
  const rest = remaining % 30;

  const parts = [];
  if (years > 0) parts.push(`${years} ${years === 1 ? 'ano' : 'anos'}`);
  if (months > 0) parts.push(`${months} ${months === 1 ? 'mês' : 'meses'}`);
  if (rest > 0) parts.push(`${rest} ${rest === 1 ? 'dia' : 'dias'}`);

  return parts.length > 0 ? parts.join(', ').replace(/,([^,]*)$/, ' e$1') : 'Hoje';
}

/** Versão curta para o resumo: "há 2 meses", "hoje". */
export function timeSinceShort(date) {
  const text = timeSince(date);
  if (text === 'Hoje') return 'hoje';
  const first = text.split(/,| e /)[0];
  return `há ${first}`;
}
